import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
    getRegionalProjectDataRequest: ['response'],
    getRegionalProjectDataSuccess: ['response'],
    getRegionalProjectDataFailure: ['error'],
})

export const getRegionalProjectDataTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
    response: null,
    success: null,
    error: null,
})

/* ------------- Reducers ------------- */

const getRegionalProjectDataRequest = state => {
    return state.merge({ success: null })
}
const getRegionalProjectDataSuccess = (state, { response }) => {
    return state.merge({
        success: true,
        error: false,
        response: response.data,
    })
}

const getRegionalProjectDataFailure = (state, { error }) => {
    const { response } = error
    return state.merge({
        success: false,
        error: true,
        response,
    })
}

export const reducer = createReducer(INITIAL_STATE, {
    [Types.GET_REGIONAL_PROJECT_DATA_REQUEST]: getRegionalProjectDataRequest,
    [Types.GET_REGIONAL_PROJECT_DATA_SUCCESS]: getRegionalProjectDataSuccess,
    [Types.GET_REGIONAL_PROJECT_DATA_FAILURE]: getRegionalProjectDataFailure,
})
